import { FiPhoneCall, FiMapPin } from 'react-icons/fi'
import { FaMapMarkerAlt } from 'react-icons/fa'

function Contact() {
  return (
    <div className='my-24'>
      <div className='flex flex-col text-center gap-y-2 md:gap-y-4'>
        <p className='text-2xl md:text-4xl text-center mb-4'>
          <strong>We'd love to hear from you</strong>
        </p>

        <div className='flex flex-col text-lg md:text-xl text-center align-center mb-3 md:mb-8'>
          <FiMapPin className='text-center mx-auto mb-2 md:mb-5' />
          <p className='text-center mb-2 md:mb-4'>
            <strong>Office</strong>
          </p>
          <p className='text-center mb-2 md:mb-4'>
            Come say hello to our office
          </p>
          33100 Transit Ave., <br />
          Union City CA 94587
        </div>
        <div className='flex flex-col text-lg text-center align-center mb-2'>
          <FiPhoneCall className='text-center mx-auto mb-2 md:mb-5' />
          <p className='text-center mb-2 md:mb-4'>
            <strong>Phone</strong>
          </p>
          <p className='text-center mb-2 md:mb-4'>Mon-Fri from 9am to 4pm</p>
          (510) 475 2650
        </div>
      </div>
    </div>
  )
}

export default Contact
